import { useCallback, useEffect, useRef, useState } from "react";
import { DEBOUNCE_DELAY } from "../Constants/config";

export function useDebounce(value, delay = DEBOUNCE_DELAY) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  const clearDebounce = useCallback((clearValue = "") => {
    setDebouncedValue(clearValue);
  }, []);

  return { debouncedValue, setDebouncedValue, clearDebounce };
}
export function useDebouncedCallback(callback, delay) {
  const timerRef = useRef(null);

  const debouncedFn = useCallback(
    (...args) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  return debouncedFn;
}
